import script from "./UploadDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./UploadDocuments.vue?vue&type=style&index=0&id=8911394a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8911394a"]])

export default __exports__